import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextLarge, HeadlineTextLarge } from 'Packages/FacetDesign/Components';


export const RetirementAgeGoalSeekFineTuneOverride = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      color: 'textSecondary',
    },
  }, overrideReadOnly)
  .nameOverride('disclaimer', {
    _component: () => BodyTextLarge,
  }, overrideReadOnly);
